import { combineReducers } from 'redux';
import sessionReducer from './features/sessions/sessionsSlice';
import themeReducer from './features/theme/themeSlice';

const appReducer = combineReducers({
  session: sessionReducer,
  theme: themeReducer,
})

export default appReducer;